module.exports = __webpack_public_path__ + "media/t_noteup.d4714441.mp4";